(function () {
  const MOBILE_MQ = window.matchMedia("(max-width: 989px)");

  function scrollActiveLinkIntoView() {
    if (!MOBILE_MQ.matches) return;

    const nav = document.querySelector(
      ".header__bottom--bargains-categories .rebx-bargains-nav"
    );
    if (!nav) return;

    const scroller = nav.querySelector(".rebx-bargains-nav__list");
    const active =
      nav.querySelector('.header__menu-item[aria-current="page"]') ||
      nav.querySelector(".rebx-bargains-nav__group--active");
    if (!scroller || !active) return;

    const target = active.closest("li") || active;
    const offset =
      target.offsetLeft - scroller.clientWidth / 2 + target.clientWidth / 2;
    scroller.scrollLeft = Math.max(0, offset);
  }

  function closeAllGroups(nav) {
    nav.querySelectorAll(".rebx-bargains-nav__group--open").forEach((group) => {
      group.classList.remove("rebx-bargains-nav__group--open");
      const trigger = group.querySelector(".rebx-bargains-nav__group-trigger");
      trigger?.setAttribute("aria-expanded", "false");
    });
  }

  function initMobileGroups(nav) {
    const groups = nav.querySelectorAll(".rebx-bargains-nav__group");
    groups.forEach((group) => {
      const trigger = group.querySelector(".rebx-bargains-nav__group-trigger");
      if (!trigger || trigger.dataset.rebxBound === "true") return;

      trigger.dataset.rebxBound = "true";
      trigger.setAttribute("aria-expanded", "false");

      trigger.addEventListener("click", (event) => {
        if (!MOBILE_MQ.matches) return;

        event.preventDefault();
        event.stopPropagation();

        const isOpen = group.classList.contains("rebx-bargains-nav__group--open");
        closeAllGroups(nav);

        if (!isOpen) {
          group.classList.add("rebx-bargains-nav__group--open");
          trigger.setAttribute("aria-expanded", "true");
        }
      });
    });

    if (!nav.dataset.rebxOutsideBound) {
      nav.dataset.rebxOutsideBound = "true";
      document.addEventListener("click", (event) => {
        if (!MOBILE_MQ.matches) return;
        if (!nav.contains(event.target)) {
          closeAllGroups(nav);
        }
      });
    }
  }

  function init() {
    const nav = document.querySelector(
      ".header__bottom--bargains-categories .rebx-bargains-nav"
    );
    if (!nav) return;

    initMobileGroups(nav);
    scrollActiveLinkIntoView();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  window.addEventListener("resize", scrollActiveLinkIntoView);
})();
